module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 4,
      "lg": 6,
      "push": 1
    }
  }, [_c('el-dialog', {
    attrs: {
      "width": "1000",
      "title": "Sales Order Sample Data",
      "visible": _vm.dialogTableVisible
    },
    on: {
      "close": function($event) {
        _vm.$emit('onClose')
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "number",
      "label": "Number",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "customerName",
      "label": "Customer Name",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Date",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "validDate",
      "label": "Valid Date",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "reference",
      "label": "Reference",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "currency",
      "label": "Currency",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "exchangeRate",
      "label": "Exchange Rate",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "taxType",
      "label": "Tax Type",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "item",
      "label": "Item",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "description",
      "label": "Description",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "quantity",
      "label": "Qty",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "unitMeasurement",
      "label": "U/M",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "price",
      "label": "Price",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "discountType",
      "label": "Discount Type",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "discountAmount",
      "label": "Discount Amount",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "salesAccount",
      "label": "Sales Account",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "tax",
      "label": "Tax",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "department",
      "label": "Department",
      "width": "80"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Sales Order date format should be "), _c('b', [_vm._v("MM/dd/yyyy")]), _vm._v(" format. You can download sample file "), _c('a', {
    attrs: {
      "href": "https://s3.amazonaws.com/workforcetrack/000000000000/invoice-import-app/public/Sales_Order_Import_Template.csv"
    }
  }, [_vm._v("here")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42dfc906"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalesOrderPopup.vue
// module id = 239
// module chunks = 1